export enum ErrorRoute {
  e403 = 'error/403',
  e404 = 'error/404',
}
